import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@devhop/ui";
import { CircleHelpIcon } from "lucide-react";
import type { ReactNode } from "react";

type FieldHelpHintProps = {
  label: ReactNode;
  children: ReactNode;
  /** Accessible name for the help control */
  ariaLabel?: string;
};

/** Label + "?" that shows a hover card with explanation. */
export function FieldHelpHint({
  label,
  children,
  ariaLabel = "ຄຳອະທິບາຍ",
}: FieldHelpHintProps) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span>{label}</span>
      <HoverCard openDelay={150} closeDelay={100}>
        <HoverCardTrigger asChild>
          <button
            type="button"
            className="inline-flex size-4 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            aria-label={ariaLabel}
            tabIndex={0}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <CircleHelpIcon className="size-3.5" aria-hidden />
          </button>
        </HoverCardTrigger>
        <HoverCardContent
          align="start"
          side="top"
          className="w-72 max-w-[min(18rem,calc(100vw-2rem))] text-pretty text-sm leading-relaxed"
        >
          {children}
        </HoverCardContent>
      </HoverCard>
    </span>
  );
}
